import { render, staticRenderFns } from "./IconTypeformMatrix.vue?vue&type=template&id=7dbe8c63&"
import script from "./IconTypeformMatrix.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformMatrix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports